import http from "../http";

export async function getApiKey(data) {
  const response = await http.get("/get-partner-credentials-for-api", data);
  return response.data;
}
